// extracted by mini-css-extract-plugin
export var browserNotSupported = "Login-module--browserNotSupported--FPZLF";